import React, { memo, useCallback } from 'react';

import { Box } from '@mui/material';
import PopTipCDS from '@sharedCR/coreDesignSystem/PopTipCDS';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { ChangeKindFilter } from '../../../../PendingChangesDrawer.constants';
import { EMPTY_COUNT_LABEL, SIDEBAR_COUNTS_CONFIG } from '../../PendingChangesSidebar.constants';

import {
  countsStyles,
  getCountStyles,
  getEmptyCountStyles,
} from './PendingChangesSidebarCounts.styles';

const PendingChangesSidebarCounts = ({
  counts,
  kinds,
  isRowSelected,
  activeKind = null,
  isSmall = false,
  onCountSelect = null,
}) => {
  const isInteractive = !_.isNil(onCountSelect);

  const onCountClick = useCallback(
    event => {
      event.stopPropagation();
      onCountSelect(event.currentTarget.dataset.kind);
    },
    [onCountSelect],
  );

  return (
    <Box sx={countsStyles}>
      {SIDEBAR_COUNTS_CONFIG.filter(({ kind }) => kinds.includes(kind)).map(
        ({ kind, tooltip, dataTestId }) =>
          counts[kind] ? (
            <PopTipCDS key={kind} title={tooltip}>
              <Box
                data-kind={kind}
                data-testid={dataTestId}
                sx={getCountStyles({
                  kind,
                  isSmall,
                  isRowSelected,
                  isInteractive,
                  isActive: activeKind === kind,
                })}
                onClick={isInteractive ? onCountClick : null}
              >
                {counts[kind]}
              </Box>
            </PopTipCDS>
          ) : (
            <Box key={kind} sx={getEmptyCountStyles(isSmall, isRowSelected)}>
              {EMPTY_COUNT_LABEL}
            </Box>
          ),
      )}
    </Box>
  );
};

PendingChangesSidebarCounts.propTypes = {
  counts: PropTypes.shape({
    [ChangeKindFilter.DIRECT]: PropTypes.number.isRequired,
    [ChangeKindFilter.RECALCULATED]: PropTypes.number.isRequired,
  }).isRequired,
  kinds: PropTypes.arrayOf(PropTypes.oneOf(Object.values(ChangeKindFilter))).isRequired,
  isRowSelected: PropTypes.bool.isRequired,
  activeKind: PropTypes.oneOf(Object.values(ChangeKindFilter)),
  isSmall: PropTypes.bool,
  onCountSelect: PropTypes.func,
};

export default memo(PendingChangesSidebarCounts);
